import {PageTransitionsToolboxOptions, Parameter} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import FunctionHelper from "../helper/FunctionHelper";

export enum PageTransitionsFunction {
	ADD = "add",
	REMOVE = "remove"
}

export class PortalPageTransitionsToolboxOptions extends PageTransitionsToolboxOptions implements Parameter {
	public mode?: PageTransitionsFunction;

	constructor(data: any) {
		super(data);

		this.mode = FunctionHelper.exists(data?.mode) ? data.mode : PageTransitionsFunction.ADD;
	}

	public static getModeDefault(): PageTransitionsFunction {
		return PageTransitionsFunction.ADD;
	}

	public static fromJson(data: any): PortalPageTransitionsToolboxOptions {
		if (!FunctionHelper.exists(data)) {
			return data;
		}

		return new PortalPageTransitionsToolboxOptions(data);
	}

	public toJson(): any {
		return {
			...super.toJson(),
			'mode': this.mode
		};
	}

	public clone(): PortalPageTransitionsToolboxOptions {
		return PortalPageTransitionsToolboxOptions.fromJson(this.toJson());
	}
}